<div class="tilepicker-component d-flex justify-content-start">
    <ng-container *ngFor="let tile of tiles">
        <div class="d-flex flex-column">
            <div class="card-container">
                <img src='assets/images/{{ tile.imgSrc}}.svg' alt="tile image">
            </div>

            <div class="flex align-items-center">
                <p-radiobutton [disabled]="disableField" name="tile" [value]="tile.type" [(ngModel)]="selectedTile"
                    [inputId]="tile.name" (onClick)="handleChange(tile.type)"></p-radiobutton>
                <label [for]="tile.name" class="ml-2">{{tile.name}}</label>
            </div>

            <!-- <div class="d-flex align-items-center" style="margin-top: 5px;margin-left: 5px;" (change)="handleChange(tile.type)" >
            <input type="radio"  name="tile" [checked]="tile.type == selectedTile"
            value ="selectedTile">
            <label class="form-check-label ml-1" for="iconIcon">{{tile.name}}</label>
        </div> -->
        </div>
    </ng-container>
</div>